<template>
  <div class="footer text-center">
    <Partnerz class="w-100 p-0 m-0 black text-white" />

    <div class="footer-top w-100 m-0 p-0">
      <div class="d-flex justify-content-center py-5">
        <a 
          v-for="item in contactInfo"
          v-bind:key="item.name"
          :href="item.link" 
          v-b-tooltip.hover
          :title="item.title"
          class="footer-link mx-3"
          :target="item.target"
        >
          <font-awesome-icon :icon="item.icon" size="3x" />
        </a>
      </div>
    </div>

    <div class="footer-bottom d-flex align-items-center justify-content-center p-1">
      <a 
        href="http://lacartoucherie.com/maestro-ged.com"
        v-b-tooltip.hover
        title="KLIX"
      >© 2019 Copyright:
      </a>

      <a 
        href="http://lacartoucherie.com/maestro-ged.com"
        v-b-tooltip.hover
        title="KLIX"
        class="d-flex align-items-center"
      >
        <b-img src="@/assets/logos/logo.png" alt="KLIX" title="" style="height: 1em;" class="pl-2"/>
      </a>
    </div>
  </div>
</template>

<script>
import Partnerz from '@/components/Partnerz.vue'

export default {
  name: 'Footer',
  components: {
    Partnerz
  },
  data() {
    return {
      contactInfo: [
        {
          link: `https://www.linkedin.com/company/la-cartoucherie/`,
          name: `LinkedIn`,
          title: `Joignez notre réseau d'affaires sur LinkedIn`,
          icon: ['fab', 'linkedin'],
          target: `_blank`
        },
        {
          link: `https://www.youtube.com/`,
          name: `Youtube`,
          title: `Notre chaîne Youtube`,
          icon: ['fab', 'youtube'],
          target: `_blank`
        },
        {
          link: `mailto:info@lacartoucherie.com`,
          name: `Email`,
          title: `Envoyez-nous un courriel à info@lacartoucherie.com`,
          icon: `at`,
          target: ``
        },
        {
          link: `tel:18195653006`,
          name: `Phone`,
          title: `Appelez-nous au (819) 565-3006`,
          icon: `mobile-alt`,
          target: ``
        },
        {
          link: "https://www.google.ca/maps/place/2520+Rue+King+Ouest,+Sherbrooke,+QC+J1J+2E8/@45.3982867,-71.9336414,17z/data=!4m13!1m7!3m6!1s0x4cb7b49ff126d68f:0x53b75ca8bae57719!2s2520+Rue+King+Ouest,+Sherbrooke,+QC+J1J+2E8!3b1!8m2!3d45.3979378!4d-71.9336447!3m4!1s0x4cb7b49ff126d68f:0x53b75ca8bae57719!8m2!3d45.3979378!4d-71.9336447?hl=fr&authuser=0",
          name: `GoogleMap`,
          title: `Venez nous voir en personne`,
          icon: `map-marked-alt`,
          target: `_blank`
        }
      ]
    }
  }
}
</script>

<style scoped>
.footer-top {
  background-color: #00B5E2;
  color: #fff
}

.footer-bottom,
.footer-bottom > a {
  background-color: #001216;
  color: #fff
}

.footer-link {
  color: #fff
}
</style>
